import markdownit from 'markdown-it';

const md = markdownit({
  html: true,
  breaks: true
});

export const parseMarkdown = (content: string | null) => {
  if (!content) return '';
  const data = content.split('\n');
  const breakCount = data.filter((i) => i == '').length;
  let lastIndex = 0;

  for (let i = 0; i < breakCount; i++) {
    const index = data.indexOf('', lastIndex);
    const newIndex = index + 1;
    data.splice(newIndex, 0, '<br />\n');
    lastIndex = newIndex;
  }

  data.splice(data.length, 0, '<br />');
  content = data.join('\n');

  return md.render(content);
};
